import React, { useCallback, useState } from 'react';

import {
    Table,
    TableHead,
    TableRow,
    TableCell,
    TablePagination,
    TableSortLabel,
} from '@mui/material';
import { makeStyles } from '@mui/styles';

const _ = require('lodash');

const PAGES = [50, 100, 200, 10000];

const useStyles = makeStyles((theme) => ({
    table: {
        marginTop: theme.spacing(3),
        '& thead th': {
            fontWeight: '600',
            color: theme.palette.primary.main,
            backgroundColor: theme.palette.primary.light,
        },

        '& tbody tr:hover': {
            // background: 'unset', //backgroundColor:'fffbf2'
            cursor: 'pointer',
        },
    },
}));
export default function useTable(records, headCells, filterFn, initialRowsPerPage = 100, initialOrderBy = undefined, initialOrder = 'asc') {
    const classes = useStyles();
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(initialRowsPerPage);
    const [order, setOrder] = useState(initialOrderBy ? initialOrder : undefined);
    const [orderBy, setOrderBy] = useState(initialOrderBy);

    // Identidad estable: si estos componentes se recrearan en cada render, React desmontaría
    // y reconstruiría toda la tabla con cada tecla escrita en la pantalla que la usa.
    const TblContainer = useCallback(
        ({ children }) => <Table className={classes.table}>{children}</Table>,
        [classes.table],
    );

    const TblHead = useCallback(() => {
        const handleSortRequest = (cellId) => {
            const isAsc = orderBy === cellId && order === 'asc';
            setOrder(isAsc ? 'desc' : 'asc');
            setOrderBy(cellId);
        };

        return (
            <TableHead>
                <TableRow>
                    {headCells.map((head) => (
                        <TableCell
                            key={head.id}
                            sortDirection={orderBy === head.id ? order : false}
                        >
                            {head.disableSorting ? (
                                head.label
                            ) : (
                                <TableSortLabel
                                    active={orderBy === head.id}
                                    direction={
                                        orderBy === head.id ? order : 'asc'
                                    }
                                    onClick={() => handleSortRequest(head.id)}
                                >
                                    {head.label}
                                </TableSortLabel>
                            )}
                        </TableCell>
                    ))}
                </TableRow>
            </TableHead>
        );
    }, [headCells, order, orderBy]);

    const count = records ? records.length : 0;
    const TblPagination = useCallback(() => (
        <TablePagination
            component='div'
            count={count}
            onPageChange={(event, newPage) => setPage(newPage)}
            onRowsPerPageChange={(event) => {
                setRowsPerPage(parseInt(event.target.value, 10));
                setPage(0);
            }}
            page={page}
            rowsPerPage={rowsPerPage}
            rowsPerPageOptions={PAGES}
        />
    ), [count, page, rowsPerPage]);

    const recordsAfterPagingAndSorting = () => {
        if (!records) {
            return [];
        }
        const sortKey = (item) => {
            const v = _.get(item, orderBy);
            return typeof v === 'string' ? v.toLowerCase() : v;
        };
        return _.orderBy(filterFn.fn(records), [sortKey], [order])
            .slice(page * rowsPerPage, (page + 1) * rowsPerPage);
    };
    return {
        TblContainer,
        TblHead,
        TblPagination,
        recordsAfterPagingAndSorting,
    };
}
